/*---------------------------------------------------------------------------------------------
 * Copyright (c) Bentley Systems, Incorporated. All rights reserved.
 * See LICENSE.md in the project root for license terms and full copyright notice.
 *--------------------------------------------------------------------------------------------*/
import * as React from 'react';
import { InputGroup } from '../InputGroup/index.js';
import '@itwin/itwinui-css/css/radio-tile.css';
import { useTheme } from '../utils/index.js';
/**
 * RadioTileGroup component to group RadioTile components together
 * @example
 * <RadioTileGroup label='My group'>
 *   <RadioTile label='First tile' icon={<SvgSmileyHappy />} />
 *   <RadioTile label='Second tile' icon={<SvgSmileySad />} />
 * </RadioTileGroup>
 */
export const RadioTileGroup = (props) => {
    const { children, label, ...rest } = props;
    useTheme();
    return (React.createElement(InputGroup, { label: label, ...rest },
        React.createElement("div", { className: 'iui-radio-tile-container' }, children)));
};
export default RadioTileGroup;
